import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQPage = () => {
  const faqs = [
    {
      question: "What services does Cordi offer for business setup in the UAE?",
      answer:
        "Cordi offers comprehensive business setup services including company formation in mainland and free zones, corporate bank account opening, tax registration, visa assistance, accounting services, and IT support tailored to your business needs.",
    },
    {
      question: "How long does it take to set up a company in the UAE?",
      answer:
        "The timeline varies depending on the jurisdiction and type of business. Typically, free zone companies can be established within 3-7 working days, while mainland companies may take 7-14 working days. Our team works efficiently to expedite the process wherever possible.",
    },
    {
      question:
        "What are the costs involved in setting up a business in the UAE?",
      answer:
        "Costs vary based on the jurisdiction, business activity, and number of visas required. Our packages start from AED X and include license fees, establishment card, and initial approvals. We provide transparent pricing with no hidden fees.",
    },
    {
      question: "What documents are required for company formation?",
      answer:
        "Generally, you'll need passport copies of all shareholders, a business plan, proof of address, and bank reference letters. Specific requirements may vary based on the jurisdiction and business activity. Our team will guide you through the exact documentation needed for your case.",
    },
    {
      question: "Can Cordi help with visa processing for my family?",
      answer:
        "Yes, we provide comprehensive visa services including investor visas, employment visas, and dependent visas for family members. Our team handles the entire process from application to stamping.",
    },
    {
      question: "What banking options are available for new businesses?",
      answer:
        "We have partnerships with leading local and international banks in the UAE. We assist with account opening applications and introductions to banking relationship managers who understand your industry needs.",
    },
    {
      question: "Does Cordi provide ongoing support after company formation?",
      answer:
        "Absolutely. We offer continuous support through our accounting services, tax compliance assistance, visa renewals, and business consulting to help your business thrive in the UAE market.",
    },
  ];

  return (
    <div className="container mx-auto py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-bold text-center mb-4">
          Frequently Asked Questions
        </h1>
        <p className="text-center text-muted-foreground mb-10">
          Find answers to common questions about our services and business setup
          in the UAE
        </p>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left font-medium">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-12 text-center">
          <h3 className="text-xl font-medium mb-4">Still have questions?</h3>
          <p className="text-muted-foreground mb-6">
            Our team is ready to assist you with any specific inquiries about
            our services
          </p>
          <button
            className="bg-coral-600 hover:bg-coral-700 text-white px-6 py-3 rounded-md font-medium"
            onClick={() => {
              // This would typically open your consultation form
              console.log("Open consultation form");
            }}
          >
            Talk to us
          </button>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
